import { FC } from "react";
import TextField from "@mui/material/TextField";
import { useFormContext } from "react-hook-form";
import { get } from "lodash";

// Interface for the Custom Text Field props.
interface ICustomTextFieldProps {
  label: string;
  name: `${string}`;
  type?: string;
  required?: boolean;
  variant?: "outlined" | "standard" | "filled" | undefined;
  disabled?: boolean;
  multiline?: boolean;
  className?: string;
  [x: string]: any;
  min?: number;
}

/**
 * Re-usable Custom Text Field.
 */
const CustomTextField: FC<ICustomTextFieldProps> = ({
  min,
  label,
  multiline,
  name,
  type,
  required = false,
  variant = "outlined",
  disabled = false,
  className = '',
  inputProps={},
  ...rest
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  const error = get(errors, name);

  return (
    <TextField
      required={required}
      label={label}
      type={type}
      multiline={multiline}
      variant={variant}
      error={!!error}
      helperText={error?.message ?? ""}
      fullWidth
      className={className}
      margin="normal"
      min={min}
      disabled={disabled}
      inputProps={inputProps}
      {...register(name)}
      {...rest}
    />
  );
};

export default CustomTextField;
